import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {IFuelSurchargeGroup, FuelSurchargeGroup} from 'app/blocks/model/fuel-surcharge-group.model';
import {Resource} from 'app/constants/resource';

import EntityCrudService from 'app/blocks/service/api/entity-service';
import {SERVER_API_URL} from 'app/app.constants';

@Injectable({
    providedIn: 'root'
})
export class FuelSurchargeGroupService extends EntityCrudService<IFuelSurchargeGroup> {
    constructor(http: HttpClient) {
        super(http, Resource.FUEL_SURCHARGE_GROUPS, (obj?) => new FuelSurchargeGroup(obj));
    }

    getOrdersUsingFuelSurchargeGroup(fuelSurchargeGroupIds: any): Promise<any> {
        return this.http.get(`${SERVER_API_URL}api/fuel-surcharge-groups/${fuelSurchargeGroupIds}/orders`).toPromise();
    }
}
